__turbopack_context__.v({
  "availabilityIcon": "ProductAvailability-module-scss-module__OH5sQq__availabilityIcon",
  "availabilityMessage": "ProductAvailability-module-scss-module__OH5sQq__availabilityMessage",
  "availabilityText": "ProductAvailability-module-scss-module__OH5sQq__availabilityText",
  "deliveryDescription": "ProductAvailability-module-scss-module__OH5sQq__deliveryDescription",
  "deliveryIcons": "ProductAvailability-module-scss-module__OH5sQq__deliveryIcons",
  "deliveryLabel": "ProductAvailability-module-scss-module__OH5sQq__deliveryLabel",
  "deliveryOptionContainer": "ProductAvailability-module-scss-module__OH5sQq__deliveryOptionContainer",
  "disabledBackground": "ProductAvailability-module-scss-module__OH5sQq__disabledBackground",
  "errorMessage": "ProductAvailability-module-scss-module__OH5sQq__errorMessage",
  "hasError": "ProductAvailability-module-scss-module__OH5sQq__hasError",
  "icon": "ProductAvailability-module-scss-module__OH5sQq__icon",
  "iconWithText": "ProductAvailability-module-scss-module__OH5sQq__iconWithText",
  "inStoreOnlyOptionsContainer": "ProductAvailability-module-scss-module__OH5sQq__inStoreOnlyOptionsContainer",
  "inputContainer": "ProductAvailability-module-scss-module__OH5sQq__inputContainer",
  "optionsContainer": "ProductAvailability-module-scss-module__OH5sQq__optionsContainer",
  "pickupMessage": "ProductAvailability-module-scss-module__OH5sQq__pickupMessage",
  "seeAllStoresButton": "ProductAvailability-module-scss-module__OH5sQq__seeAllStoresButton",
  "selectButton": "ProductAvailability-module-scss-module__OH5sQq__selectButton",
  "selectStoreButton": "ProductAvailability-module-scss-module__OH5sQq__selectStoreButton",
  "selectedStoreButton": "ProductAvailability-module-scss-module__OH5sQq__selectedStoreButton",
  "shippingIcon": "ProductAvailability-module-scss-module__OH5sQq__shippingIcon",
  "shippingOption": "ProductAvailability-module-scss-module__OH5sQq__shippingOption",
  "strikethrough": "ProductAvailability-module-scss-module__OH5sQq__strikethrough",
});
